const template = require('./format-legality.tpl').default;

module.exports = DomClass(template, function() {
});
